import React from 'react';
import PropTypes from 'prop-types';

// import components
import { withEnvironmentContext } from '@embeds/core/EnvironmentContext';

// import utils
import { linkTracking } from '@utils/analytics/index';
import akamaiImageUrl from '@utils/embeds/common/imageurl';


export const BrandImage = ({ image }) => {
  const imageSrc = akamaiImageUrl(image);
  return (<img className="et-common_sponsor_img" src={imageSrc} alt="" />);
};

const BrandPanel = ({ sponsordata, id, type, envData, ...props }) => {
  const createSponsorList = () => {
    let list = sponsordata.sponsorData.map((obj, index) => {
      if (obj.image && obj.image !== null) {
        return (
          <div className='sponsorList' key={index}>
            <span className="et-common_sponsor_btyb">{obj.sponsorMessage ? obj.sponsorMessage : 'Brought to you by'}</span>
            {obj.link ? (
              <div className="sponsor_img_container">
                <a href={obj.link} target="_blank" rel="noopener noreferrer" className="sponsor_link" onClick={() => linkTracking(envData, { id, type }, 'sponsor', 1, { href: obj.link })}>
                  <BrandImage image={obj.image} />
                </a>
              </div>
            ) : (
              <BrandImage image={obj.image} />
            )}
          </div>
        )
      }
    })
    return list;
  }
  
  return (
    <>
      {
        sponsordata && sponsordata.sponsorData ?
          <div className="et-common_sponsor" {...props}>
            {createSponsorList()}
          </div>
          : null
      }
    </>
  )
};

BrandPanel.propTypes = {
  sponsordata: PropTypes.object,
  id: PropTypes.number,
  type: PropTypes.string.isRequired,
  envData: PropTypes.object.isRequired,
};

BrandPanel.defaultProps = {
  sponsordata: {},
};

export default withEnvironmentContext(BrandPanel);
